import React, { FC } from 'react';
import * as classes from './HeroSection.module.scss';
import Container from '../../../../../Common/Container/Container';
import { ServiceHeroSectionProps } from '../../../../../Sections/Services/HeroSection/HeroSection';

const HeroSection: FC<ServiceHeroSectionProps> = ({ image }) => {
  return (
    <Container className={classes.wrapper}>
      <div data-aos='fade-in'>{image && <img src={image} alt={''} className={classes.image} />}</div>
    </Container>
  );
};

export default HeroSection;
